module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm1"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%",
      "text-align": "center",
      "margin-top": "2em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_vm._v("T")]), _vm._v("hig crioch air an t-saoghal, ach mairidh gaol is ceòl.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%",
      "text-align": "center"
    }
  }, [_vm._v("The world will end but love and music endure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%",
      "text-align": "center",
      "margin-top": "2em"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images",
      "src": "images/open.jpg"
    }
  }), _vm._v(" SCOTTISH GAELIC PROVERB "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images",
      "src": "images/close.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4874b01e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545539364_fm001.vue
// module id = 66
// module chunks = 0